<template>
	<div class="container-fluid container-principal vertical-center">
		<div class="row portada d-flex align-items-center">
			<div class="container">
				<div class="row align-items-center">
					<div class="col col-12 col-lg-6 titulo-portada">
						<img class="logo-micrositio" src="../../src/assets/logo.svg" alt="">
						<h1 class="titulo-dependencia">Unidad de Vigilancia</h1>
						<p class="bienvenida">Bienvenido al Micrositio de Declaraciones de Situación Patrimonial y de Intereses de las Personas Servidoras Públicas de la Auditoría Superior del Estado de Quintana Roo.</p>

						<div>
							<b-button id="show-btn" @click="$bvModal.show('bv-modal-example')" class="link-principal">Realiza tus Declaraciones</b-button>

							<b-modal id="bv-modal-example" hide-footer>
								<template slot="modal-title">
									Avisos de Privacidad
								</template>
								<div class="d-block text-center">
									<p>Le sugerimos leer el Aviso de Privacidad antes de continuar con su declaración.</p>
									<div class="container modal-avis-priv">
										<div class="row">
											<div class="col-sm container-link">
												
												<a href="http://documentos.congresoqroo.gob.mx/declaranet/uv/ap-uv-integral.pdf" target="_blank">
													Aviso de Privacidad<br>Integral
												</a>
													
											</div>
										</div>
									</div>
									<p><a class="link-principal" href="http://sistemadeclaranetuv.congresoqroo.gob.mx/" target="_blank" role="button">Continuar</a></p>
								</div>
							</b-modal>
						</div>
						<de-countdown></de-countdown>
					</div>
					<div class="col col-12 col-lg-6 imagen-portada d-none d-sm-block">
						<img src="../../src/assets/vector_laptop.svg" alt="">
					</div>
				</div>
				
			</div>
		</div>
	</div>

</template>

<script>
import DeCountdown from './Countdown.vue'

export default {
  name: 'index',
  components: { DeCountdown },
  data () {
	return {
	}
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Index.vue